<template>
  <div class="active-monitoring-toggle">
    <v-switch
      :disabled='isToggleDisabled'
      v-model="item[column.name]"
    ></v-switch>
    <div :class="['label', { colorBoolean }]">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActiveMonitoringTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    colorBoolean() {
      return (!this.isToggleDisabled && this.toggleValue);
    },
    isToggleDisabled() {
      return true;
    },
    toggleValue() {
      return this.item[this.column.name];
    },
    label() {
      return this.toggleValue ? this.$t('active.monitoring.on') : this.$t('active.monitoring.off');
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.active-monitoring-toggle{
  display: flex;
  align-items: center;
  padding-left: 11%;
}
.label {
  flex: 1;
  padding-left: 5%;
  height: 20px;
  width: 18px;
  color: var(--text-tertiary);
  font-family: $font-family-medium;
  font-size: $font-size-base;
  letter-spacing: 0;
  line-height: 20px;

  &.colorBoolean {
     color: var(--info-500);
  }
}
</style>
